import { createUseStyles } from 'react-jss';

import { ITheme } from 'types';

const useStyles = createUseStyles((theme: ITheme) => ({
  tooltip: {
    color: theme.colors.texts.base,
    backgroundColor: theme.colors.backgrounds.positive,
    padding: theme.spacings.s2,
    fontWeight: 500,
    fontSize: 12,
    border: 0,
    marginTop: 8,
    '& > div path': {
      fill: `${theme.colors.backgrounds.positive}!important`,
    },
  },
}));

export default useStyles;
